/**
 * Sums one price field across the stay dates.
 * @param {Array} dates rate dates with per-night prices and taxes
 * @param {string} priceKey field to sum (e.g. 'final_price', 'price')
 * @param {boolean} showTax merchant search_room_is_show_tax_fee_note flag
 * @param {boolean} deductTaxes subtract taxes when the merchant hides them
 * @returns {number} total price
 */
export function getTotalPriceFromDate(dates, priceKey, showTax, deductTaxes = false){
  let total = 0;
  let totalTaxes = 0;
  dates.forEach(date => {
    total += date[priceKey];
    totalTaxes += date.taxes;
  })
  if(!showTax && deductTaxes) total -= totalTaxes
  return total
}

/**
 * @param {number} price nightly price
 * @param {number} taxes nightly taxes
 * @param {boolean} showTax merchant search_room_is_show_tax_fee_note flag
 * @returns {number} price with or without taxes per merchant config
 */
export function printTotalPriceWithTax(price, taxes, showTax){
  return showTax ? price : price - taxes
}

/**
 * @param {number} finalPrice discounted total
 * @param {number} basePrice original total
 * @returns {number} discount percentage rounded to 2 decimals
 */
export function discountAccumulation(finalPrice, basePrice){
  const display = ((basePrice - finalPrice) * 100) / basePrice;
  return +parseFloat(display).toFixed(2);
}

/**
 * A discount exists when applied non-occupancy promos reduce the total price.
 * @param {Array} dates rate dates with promo_combine data
 * @returns {boolean}
 */
export function checkDiscount(dates){
  let totalPromoPrice = 0

  dates.forEach(date => {
    if(date.promo_combine != null){
      const validPromos = date.promo_combine.promotion_list.filter(x => x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
      if(validPromos.length > 0){
        totalPromoPrice += date.promo_combine.total_promotion_price
      }
    }
  })

  return totalPromoPrice < 0
}

function isAppliedDiscountPromo(promo){
  return promo.promotion_price < 0 && promo.promotion_type != 'REMAINING_OCCUPANCY' && promo.is_apply == true
}

/**
 * Names the applied discount promos across the stay, matching the style 1 tag.
 * @param {Array} dates rate dates with promo_combine data
 * @returns {string} single promo name, "<last> and N Other", or '' when none
 */
export function getAppliedPromotionLabel(dates){
  const promos = []
  dates.forEach(date => {
    if(date.promo_combine == null) return
    date.promo_combine.promotion_list.forEach(promo => {
      const isListed = promos.some(listed => listed.id == promo.id)
      if(isAppliedDiscountPromo(promo) && !isListed) promos.push(promo)
    })
  })

  if(promos.length == 0) return ''
  const lastPromoName = promos[promos.length - 1].name
  if(promos.length == 1) return lastPromoName
  return `${lastPromoName} and ${promos.length - 1} Other`
}



// WEBPACK FOOTER //
// ./src/components/hotel/be/v3/room-card/pricing.js